import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
import { login, setLoginMode } from "actions/loginActions";
import { tryDetectOAuth } from "actions/commonActions";
import { setLanguage } from "actions/localizationActions";
import { RouteMap } from "components/common/navigation/routeMap";
import { clearSystemMessage } from "actions/systemMessageActions";

const mapStateToProps = (state, { query: { redirectTo } }) => {
  // This is easier to debug
  const {
    app: { client, clientName },
    login,
    localization,
    common: { clientSettings, logoUrl, settingsLoaded, settingsLoadingFailed, faqUrl, faqLabel },
  } = state;

  return {
    client,
    clientName,
    faqUrl,
    faqLabel,
    loginState: login, // 2 logins! one is a reducer, and another an action.  so must rename one of them  :(
    loginConfig: (clientSettings || { login: {} }).login,
    settingsLoaded: settingsLoaded,
    settingsLoadingFailed: settingsLoadingFailed,
    user: login.user,
    isAuthenticated: login.isAuthenticated,
    resourceId: login.resourceId,
    initialValues: {
      clientName,
      loginMode: login.loginMode,
    },
    localization,
    languages: localization.languages,
    selectedLanguage: localization.selectedLanguage,
    logoUrl,
    loginLabel: clientSettings ? clientSettings.loginLabel : null,
    redirectTo: redirectTo
      ? decodeURI(redirectTo)
      : login.user &&
        login.user.hrAdmin &&
        !login.user.employee &&
        login.user.pendingAuthActions.length == 0
      ? RouteMap.ReportsMain
      : _.get(login.user, "websiteConfig.portal"),
  };
};

const mapDispatchToProps = {
  login,
  setLanguage,
  setLoginMode,
  tryDetectOAuth,
  clearSystemMessage,
};

export function containerizeLoginCmp(component) {
  return withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(component)));
}



// WEBPACK FOOTER //
// ./components/login/containerizeLoginCmp.jsx